export default {
  ACCEPTED_FORMATS: '(Formats acceptés : JPEG, PNG, JPG)',
  ACCOUNTING_CODE: 'Code comptable',
  ACTIONS: 'Actions',
  ACTIVE: 'Actif',
  ACTIVE_ORDER_FILTER: 'Filtre des commandes actives',
  ACTIVE_ORDERS: 'Comamndes actives',

  ADD: 'Ajouter',
  ADD_CATEGORY: 'Ajouter une catégorie',
  ADD_INGREDIENT: 'Ajouter un ingrédient',
  ADD_NEW_TAX: 'Ajouter une nouvelle taxe',
  ADD_PRODUCT: 'Ajouter un produit',
  ADD_STORE: 'Ajouter Client',
  ADD_SUB_CATEGORY: 'Ajouter une sous-catégorie',
  ADD_SUPPLIER: 'Ajouter un fournisseur',
  ADD_TAX: 'Ajouter la taxe',
  ADDING_NEW_CATEGORY_DETAILS:
    "Ajout des détails d'une nouvelle catégorie en cours ...",
  ADDING_NEW_INGREDIENT_DETAILS:
    "Ajout des détails de l'ingrédient en cours...",
  ADDING_NEW_NOTE: "Ajout d'une nouvelle note en cours ...",
  ADDING_NEW_PRODUCTS_DETAILS:
    'Ajout des détails du nouveau produit en cours...',
  ADDING_NEW_SUB_CATEGORY_DETAILS:
    "Ajout des détails d'une nouvelle sous-catégorie en cours ...",
  ADDRESS: 'Adresse',

  APPLY: 'Appliquer',
  ASSIGN: 'Assigner',
  ASSIGN_PRODUCT: 'Assigner un produit...',
  ASSIGNED_PRODUCTS: 'Produits assignés',
  ASSIGNMENT: 'Affectation',
  AUTHENTICATING: 'Authentification en cours...',

  BACK_ORDER: 'Commande en attente',
  BACKORDER: 'Commande en attente',
  BAKEASY_SUPPLIER_PORTAL: 'Portail Fournisseur Order-EZ',
  BILL_DATE: 'Date de la facture',
  BILL_ID: 'Identifiant de la facture',
  BILL_TO: 'Facturé à',
  BILL_TO_NAME: 'Nom',
  BILLING_DETAILS: 'Détails de la facture',

  CANCEL: 'Annuler',
  CANCEL_ORDER: 'Annuler commande',
  CANCELLING_ORDER_STATUS: 'Statut de commande en cours d’annulation',
  CATEGORIES: 'Catégories',
  CATEGORY: 'Catégorie',
  CATEGORY_NAME: 'Nom de la catégorie',

  CHAIN_STORE_NAME: 'Nom de la chaîne de magasins',
  CHAIN_STORE_PARENT: 'Chaîne de magasins/Société mère',
  CHANGE_PASSWORD: 'Changer le mot de passe',
  CHECK: 'Vérifier',
  CITY: 'Ville',
  CLEAR: 'Effacer',
  CLOSE: 'Fermer',

  COMPANY_ADDRESS: 'Adresse de la compagnie',
  COMPANY_NAME: 'Nom compagnie',
  COMPOSE: 'Composer',

  CONFIRM: 'Confirmer',
  CONFIRM_INVOICE_DETAILS: 'Confirmer Détails de facturation',
  CONFIRM_QUANTITY: 'Confirmer la quantité',
  CONFIRM_PASSWORD: 'Confirmer le mot de passe',
  CONFIRM_PRODUCTION: 'Confirmer la production',
  CONSOLIDATED_RECIPE_BUILDER_BY_MULTIPLE_PRODUCT:
    'Créateur de recettes consolidé par plusieurs produits',

  CONTACT: 'Contact',
  CONTACT_ACCOUNTING: 'Contact comptabilité',
  CONTACT_BAKEASY:
    "Contacter Bakeasy pour ajouter l'option créateur de recettes",
  CONTACT_STORE: 'Contact Client',
  CONTACT_SUPPORT: 'Veuillez contacter le Support Technique du Système',
  CONTACT1: 'Contact 1',
  CONTACT2: 'Contact 2',
  CONTENT: 'Contenu',
  COST_PRICE: 'Prix de revient',
  COUNTRY: 'Pays',
  CREATE: 'Créer',
  CREATE_ORDER: 'Créer une commande',
  CREATE_SHIPPING_MEMO_ONLY: 'Créer le bordereau d’expédition seulement',
  CREATE_SHIPPING_MEMO_INVOICE: 'Créer Bordereau d’expédition et Facture',
  CREATED_DATE: 'Date de création',
  CREATING_INVOICE: 'Création de facture',
  CURRENT_PASSWORD: 'Mot de passe actuel',
  CUSTOMER: 'Client',

  DATE: 'Date',
  DATE_CREATED: 'Date de création',
  DATE_MM_DD_YYYY: 'Date',
  DATE_ORDERED: 'Date de commande',
  DATE_REGISTERED: "Date d'enregistrement",
  DATE_REGISTERED_AS_STORE: 'Date d’enregistrement Client',
  DATE_TO_BE_DELIVERED: 'Date prévue de livraison',

  DEACTIVATE: 'Désactiver la',
  DEACTIVATE_CATEGORY: 'Désactiver la catégorie',
  DEACTIVATE_CATEGORY_MESSAGE:
    'Êtes-vous sûr(e) de vouloir désactiver cette catégorie?',
  DEACTIVATE_SUB_CATEGORY: 'Désactiver la sous-catégorie',
  DEACTIVATE_SUB_CATEGORY_MESSAGE:
    'Êtes-vous sûr(e) de vouloir désactiver cette sous-catégorie?',
  DEACTIVATE_STORE: 'Désactiver Client',
  DEACTIVATE_STORE_MESSAGE:
    'Êtes-vous sûr(e) de vouloir désactiver ce client ?',
  DEACTIVATING_PRODUCT: 'Désactivation du produit en cours...',
  DEACTIVATING_STORE: 'Désactivation Client en cours...',

  DELETE: 'Supprimer',
  DELETE_MESSAGE: 'Supprimer message',
  DELETE_MESSAGE_CONFIRMATION:
    'Êtes-vous sûr(e) de vouloire supprimer ce message ?',
  DELETING_MESSAGE: 'Suppression du message...',
  DELIVERED_DATE: 'Date de livraison passée',
  DELIVERED_ORDER: 'Commande livrée',
  DELIVERIES: 'Livraisons',
  DELIVERY_DATE: 'Date de livraison',
  DELIVERY_ID: 'Identifiant de la livraison',
  DESCRIPTION: 'Description',

  DIFFERENT_LEGAL_NAME: 'Nom légal différent',
  DISCOUNT_PER: 'Remise % du prix du détail',

  DOWNLOAD_FAILS: 'Échec de téléchargement',
  DOWNLOAD_SUCCESS: 'Succès du téléchargement',
  DOWNLOADING_CATEGORIES: 'Téléchargement des catégories en cours ...',
  DOWNLOADING_NEW_ORDER_SUMMARY:
    'Téléchargement du résumé de la nouvelle commande en cours...',
  DOWNLOADING_ORDERS: 'Téléchargement des commandes en cours...',
  DOWNLOADING_PRODUCT: 'Téléchargement des produits en cours...',
  DOWNLOADING_PRODUCT_DETAILS:
    'Téléchargement des détails du produit en cours...',
  DOWNLOADING_STORE: 'Téléchargement Client en cours ...',
  DOWNLOADING_STORE_DETAILS: 'Téléchargement détails Client en cours ...',
  DOWNLOADING_STORE_PRODUCTS: 'Téléchargement Produits du Client en cours ...',
  DOWNLOADING_SUBCATEGORIES: 'Téléchargement des sous-catégories en cours...',
  DUE_DATE: "Date d'échéance",
  DUPLICATE: 'Reproduire',
  DOES_NOT_ACCEPT_BACKORDERS:
    "Ce client n'accepte pas les commandes en attente", //Store-customer

  EDIT: 'Modifier',
  EDIT_CATEGORY: 'Modifier la catégorie',
  EDIT_ORDER: 'Modifier la commande',
  EDIT_PRODUCT: 'Modifier le produit',
  EDIT_STORE: 'Modifier Client',
  EDIT_SUB_CATEGORY: 'Modifier la sous-catégorie',
  EMAIL: 'Adresse e-mail',
  EMAIL_ID: 'Identifiant e-mail',

  ENTER: 'Saisir',
  ENTER_ACCOUNTING_CODE: 'Saisir le code comptable',
  ENTER_CHAIN_STORE_NAME: 'Saisir le nom de la chaîne de magasins',
  ENTER_EMAIL_ID: "Saisir l'identifiant e-mail",
  ENTER_FIRST_NAME: 'Saisir le prénom',
  ENTER_LAST_NAME: 'Saisir le nom de famille',
  ENTER_LEGAL_NAME: 'Saisir le nom légal',
  ENTER_MESSAGE: 'Saisir le message',
  ENTER_MOBILE_NUMBER: 'Saisir le numéro de téléphone mobile',

  ENTER_PARENT_ADDRESS: "Saisir l'adresse de la société mère",
  ENTER_PARENT_CITY: 'Saisir la ville de la société mère',
  ENTER_PARENT_COUNTRY: 'Saisir le pays de la société mère',
  ENTER_PARENT_POST_CODE: 'Saisir le code postal de la société mère',
  ENTER_PARENT_STATE: "Saisir l'État/province de la société mère",

  ENTER_PASSWORD: 'Saisir le mot de passe',
  ENTER_PRODUCT_NAME: 'Enter Product Name', //not used

  ENTER_SHIPPING_RATE: "Saisir le tarif d'expédition",
  ENTER_STORE_ADDRESS: 'Saisir Adresse Client',
  ENTER_STORE_CITY: 'Saisir Ville Client',
  ENTER_STORE_COUNTRY: 'Saisir Pays Client',
  ENTER_STORE_DISCOUNT: 'Saisir Réduction Client',
  ENTER_STORE_NAME: 'Saisir Nom Client',
  ENTER_STORE_POSTAL_CODE: 'Saisir ZIP/Code postal Client',
  ENTER_STORE_STATE: 'Saisir État/Province Client',

  ENTER_USER_NAME: "Saisir le nom d'utilisateur",
  ENTER_WORK_PHONE_NUMBER: 'Saisir le numéro de téléphone du travail',
  ENTER_YOUR_PASSWORD: 'Saisir votre mot de passe',
  ENTER_YOUR_USERNAME: "Saisir vore nom d'utilisateur",

  ESTIMATED_SHIPPING_CHARGES: "Estimation des frais d'expédition",
  ESTIMATED_TAXES_1: 'Estimation des taxes 1',
  ESTIMATED_TAXES_2: 'Estimation des taxes 2',
  EXPECTED_DATE: 'Estimation de la date',
  EXPORT: 'Exportation',

  FETCHING_ACTIVE_ORDERS: 'Récupération Commandes actives en cours ...',
  FETCHING_CATEGORIES: 'Récupération des catégories en cours...',
  FETCHING_CATEGORIES_DETAILS:
    'Récupération des détails des catégories en cours...',
  FETCHING_COUNTRIES: 'Récupération des pays en cours...',
  FETCHING_INGREDIENTS: 'Récupération des ingrédients en cours...',
  FETCHING_INVOICES: 'Récupération des factures en cours...',
  FETCHING_NAMES: 'Récupération des noms en cours...',
  FETCHING_MESSAGE_STATUS: "Récupération de l'état du message en cours...",
  FETCHING_MESSAGES: 'Récupération des messages en cours …',
  FETCHING_PRODUCT_NAMES: 'Récupération Noms Produits en cours ...',
  FETCHING_PRODUCTS: 'Recherche des produits en cours...',
  FETCHING_PRODUCTS_DETAILS: 'Recherche des détails des produits...',
  FETCHING_ORDER_DETAILS: 'Récupération des détails de la commande en cours...',
  FETCHING_ORDERPROCESSING:
    'Récupération du traitement de la commande en cours...',
  FETCHING_ORDERPROCESSING_DETAILS:
    'Récupération des détails du traitement de la commande en cours...',
  FETCHING_ORDERS: 'Récupération des commandes en cours...',
  FETCHING_RECIPE: 'Récupération de la recette en cours...',
  FETCHING_RECIPE_DETAILS: 'Récupération des détails de la recette en cours...',
  FETCHING_REPLIES: 'Recherches des réponses en cours...',
  FETCHING_SHIPPING_METHODS: 'Recherche des expéditions en cours …',
  FETCHING_SHIPPINGS: 'Recherche des expéditions...',
  FETCHING_SHIPPINGS_DETAILS:
    "Recherche des détails de l'expédition en cours...",
  FETCHING_STATES: 'Recherches des États en cours...',
  FETCHING_STORES: 'Recherche Clients en cours...',
  FETCHING_STORES_DETAILS: 'Recherche détails Clients en cours…',
  FETCHING_SUBCATEGORIES: 'Recherche des sous-catégories en cours...',
  FETCHING_TAX: 'Recherche des taxes...',

  FILE_SIZE_MSG:
    'La taille du fichier dépasse la limite de 2 Mo. Veuillez choisir un fichier plus petit',
  FILTER: 'Filtre',
  FIRST_NAME: 'Prénom',
  FORGOT_PASSOWRD: 'Mot de passe oublié ?',
  FROM: 'De',

  GENERAL_PRODUCT_COST: 'Coût général du produit',
  GENERATE: 'Générer',
  GETUSER_PROFILE: 'Obtenir le profil utilisateur...',
  GREATER_THAN_ZERO: 'Supérieur à zéro',

  HIGH_PRIORITY: 'Priorité élevée',

  INACTIVE: 'Inactif',
  INGREDIENT: 'Ingrédients',
  INGREDIENT_IMAGE: "Image de l'étiquette des ingrédients",
  INGREDIENT_NAME: "Nom de l'ingrédient",
  INGREDIENT_QUANTITY: 'Quantité d’ingrédient',
  INGREDIENTS: 'Ingrédients',

  INVOICE: 'Factures',
  INVOICE__ID: 'Identifiant de la facture',
  INVOICE_DATE: 'Date de la facturation',
  INVOICE_DETAILS: 'Détails de la facture',
  INVOICE_FILTER: 'Filtre sur facture',
  INVOICE_ID: 'Identifiant de la facture',
  INVOICE_QUANTITY: 'Quantité facturée',
  INVOICED_DATE: 'Date de la facture',
  INVOICED_VALUE: 'Valeur facturée',
  INVOICES: 'Factures',

  IS_NOT_SAME: "N'est pas le même",
  IS_REQUIRED: 'est requis',

  KEEP_AS_NEW: 'Conserver comme neuf',

  LANGUAGE: 'Langue',
  LANGUAGES: 'Langues',
  LAST_ACCESS: 'Dernier accès',
  LAST_NAME: 'Nom de famille',
  LAST_ORDER_DATE: 'Date de la dernière commande',
  LEGAL_NAME: 'Nom légal',
  LOGGED_IN_SUCCESSFULLY: 'Connexion réussie',
  LOGOUT: 'Déconnexion',

  MEASURE_PER_UNITS: 'Mesure par unité',
  MEASURE_TYPE: 'Type de mesure',
  MESSAGES: 'Messages',
  MESSAGE_COMPOSE: "Rédaction d'un message",
  MESSAGE_FILTERS: 'Filtres message',
  MESSAGES_THREAD: 'Fil de messages',
  METHOD: 'Méthode',
  METHODS: 'Méthodes',
  MOBILE: 'Téléphone mobile',

  MODIFYING_LANGUAGE: 'Modification de la langue en cours...',
  NEW_STORE_ADDED_SUCCESSFULLY: 'Nouveau Client ajouté avec succès',
  MODIFYING_PRODUCTS_DETAILS: 'Modification des détails du produit en cours...',
  MINIMUM_DELIVERY_TIMEFRAME: 'Délai de livraison minimum',
  MESSAGE_IS_REQUIRED: 'Message requis',
  MODIFY_STORE_DETAILS: 'Modification détails Client en cours ...',
  NOTE_CREATED_SUCCESSFULLY: 'Note créée avec succès',
  MODIFYING_PROFILE: 'Modification du profil en cours...',

  NAME: 'Nom',
  NEW: 'Nouveau',
  NEW_MESSAGE: 'Nouveau message',
  NEW_ORDER_SUMMARY: 'Résumé de la nouvelle commande',
  NEW_PASSWORD: 'Nouveau mot de passe',
  NO: 'Non',
  NO_DATA_FOUND: 'Aucune donnée disponible',
  NO_STORE_NOTES_AVAILABLE: 'Aucune Remarque Client disponible',
  NO_SUBORDERS_PRESENT: 'Aucun sous‑ordre présent',
  NO_YES: 'OUI / NON',
  NOT_APPLICABLE: 'Non Applicable',
  NOTE: 'Note',
  NORMAL: 'Normal',
  NUTRITION_IMAGE: "Image de l'étiquette nutritionnelle",

  OK: 'Ok',
  ORDER__DATE: 'Date de la commande',
  ORDER_BY: 'Commande par',
  ORDER_DATE: 'Date de la commande',
  ORDER_DETAILS: 'Détails de la commande',
  ORDER_FILTER: 'Filtre de commandes',
  ORDER_ID: 'Identifiant de commande',
  ORDER_INFO: 'Information sur la commande',
  ORDER_PROCESSING: 'Traitement de la commande',
  ORDER_STATUS: 'Statut de la commande',
  ORDERED: 'Commandé',
  ORDERS: 'Commandes',
  OTHER_DETAILS: 'Autres détails',

  PACKED: 'Emballé',
  PACKED_AND_SHIPPING: "Emballé et en cours d'expédition",
  PARENT_ADDRESS: 'Adresse de la société mère',
  PARENT_CITY: 'Ville de la société mère',
  PARENT_COUNTRY: 'Pays de la société mère',
  PARENT_EMAIL_ID: 'Adresse e-mail de la société mère',
  PARENT_POSTAL_CODE: 'Code postal de la société mère',
  PARENT_STATE: 'État/province de la société mère',
  PARENT_WORK: 'Projet principal',
  PARENT_WORK_NUMBER: 'Numéro de téléphone de travail de la société mère',

  PASSWORD: 'Mot de passe',
  PASSWORD_UPDATED_SUCCESSFULLY_LOGGING_OUT:
    'Mot de passe principal mis à jour avec succès, déconnexion...',
  PAYMENT: 'Paiement',
  PAYMENT_TERMS: 'Conditions de paiement',
  PAYMENT_DUE_DATE: "Date d'échéance du paiement",
  PENDING_ORDER: 'Commande en attente',
  PHONE: 'Téléphone',

  PLEASE_ENTER_DESCRIPTION: 'Veuillez saisir la description',
  PLEASE_ENTER_SUBJECT: 'Veuillez saisir le sujet',
  PLEASE_ENTER_VALID: 'Veuillez vérifier la validité du ',
  PLEASE_ENTER_VALID_CREDINALS: 'Veuillez saisir des références valides',
  PLEASE_SELECT_NAME: 'Veuillez sélectionner un nom',
  PLEASE_TYPE_ASSIGN: 'Veuillez taper ASSIGNER',
  PLEASE_TYPE_UNASSIGN: 'Veuillez taper DÉSASSIGNER',
  PLEASE_SELECT_ORDER_TO_CANCEL:
    'Veuillez sélectionner les commandes à annuler',
  PLEASE_UPLOAD:
    "Veuillez télécharger une image d'une taille inférieure à 2 MB",

  POSTAL_CODE: 'Code postal',
  PREFERRED_SHIPPING_METHOD: "Mode d'expédition souhaité",
  PREVIEW_CONSOLIDATED_RECIPE_BUILDER:
    'Aperçu du créateur de recettes consolidé',
  PRICE: 'Prix',
  PRINT: 'Imprimer',
  PRIORITY: 'Priorité',

  PROCEDDING_ORDER: 'Commande en cours',
  PROCEED: 'Continuer',
  PROCESS: 'Traiter',
  PROCESS_ALL: 'Tout traiter',
  PROCESS_WITH_BACK_ORDER: 'Traitement avec commande en attente',

  PRODUCT: 'Produit',
  PRODUCT_DETAILS: 'Détails du produit',
  PRODUCT_FILTER: 'Filtre produit',
  PRODUCT_ID: 'Identifiant du produit',
  PRODUCT_IMAGE: 'Image du produit',
  PRODUCT_NAME: 'Nom du produit',
  PRODUCT_QUANTITY: 'Quantité du produit',
  PRODUCT_STATUS: 'Statut du produit',
  PRODUCT_TYPE: 'Type du produit',
  PRODUCTS: 'Produits',
  PRODUCTS_OFFERED: 'Produits proposés',
  PRODUCTION_DATE: 'Date de production',
  PRODUCTION_ID: 'Identifiant de production',
  PRODUCTION_PLAN: 'Plan de production',
  PRODUCTION_PLAN_PREVIEW: 'Aperçu du plan de production',
  PRODUCTION_REPORT_HISTORY: 'Historique des rapports de production',
  PRODUCTION_REPORT: 'Rapport de production',
  PRODUCTION_REPORT_DETAILS: 'Détails Rapport de production',
  PRODUCTION_REPORTS: 'Rapports de production',

  PROFILE: 'Profil',
  PROFILE_SETTINGS: 'Profil et paramètres',
  PROVINCE: 'Province',

  QR_CODE: 'Code QR',
  QUANTITY: 'Quantité',
  QUANTITY_INVOICED: 'Quantité facturée',
  QUANTITY_ORDERED: 'Quantité commandée',
  QUANTITY_PER_UNIT: 'Quantité par unité',
  QUANTITY_SENT: 'Quantité envoyée',
  QUANTITY_SHIPPED: 'Quantité expédiée',

  RATE1: 'Taux 1',
  RATE2: 'Taux 2',
  RATE_1: 'Taux 1',
  RATE_2: 'Taux 2',

  REACTIVATE: 'Réactiver la',
  REACTIVATE_CATEGORY: 'Réactiver la catégorie',
  REACTIVATE_CATEGORY_MESSAGE:
    'Êtes-vous sûr(e) de vouloir réactiver cette catégorie ?',
  REACTIVATE_STORE: 'Réactiver Client',
  REACTIVATE_STORE_MESSAGE: 'Êtes-vous sûr(e) de vouloir réactiver ce client ?',
  REACTIVATE_SUB_CATEGORY: 'Réactiver la sous-catégorie',
  REACTIVATE_SUB_CATEGORY_MESSAGE:
    'Êtes-vous sûr(e) de vouloir réactiver cette sous-catégorie ?',
  REACTIVATING_PRODUCT: 'Réactivation du produit en cours...',
  REACTIVATING_STORE: 'Réactivation Client en cours...',
  READ: 'Lu',
  REC_SENT: 'Reçu-envoyé',
  RECIPE: 'Créateur',
  RECIPE_BUILDER: 'Créateur de recettes',
  RECIPE_BUILDER_BY_SINGLE_PRODUCT: 'Créateur de recettes pour produit unique',
  RECIPE_BUILDER_INGREDIENTS: 'Ingrédients du créateur de recettes',
  RECIPE_BUILDER_REPORT: 'Rapport du créateur de recettes',
  RECIPE_BUILDER_TYPE: 'Type de créateur de recettes',
  RECIPE_BUILDER_NOT_AVAILABLE_FOR_PURCHASED_PRODUCTS:
    'Créateur de Recettes non disponible pour Produits achetés',

  REMEMBER_ME: 'Se souvenir de moie',
  REPLY: 'Répondre',
  REPORTS: 'Rapports',
  REQUESTED_DATE: 'Date souhaitée',
  REQUESTED_DELIVERY_DATE: 'Date de livraison souhaitée',
  RETAIL_PRICE: 'Prix de détail',

  SAVE: 'Sauvegarder',
  SAVE_CHANGES: 'Enregistrer les modifications',
  SAVE_NOTE: 'Enregistrer la note',
  SEARCH: 'Rechercher',

  SELECT: 'Sélectionner ',
  SELECT_BACKORDER: 'Sélectionner les commandes en attente',
  SELECT_BILL_TO: 'Sélectionner Facturer à',
  SELECT_CATEGORY: 'Sélectionner Catégorie',
  SELECT_DATE: 'Sélectionner Date',
  SELECT_FROM: 'Sélectionner De',
  SELECT_INGREDIENT: 'Sélectionner Ingrédient',
  SELECT_LANGUAGE: 'Sélectionner Langue',
  SELECT_ORDERS_TO_CANCEL: 'Sélectionner Commandes à annuler',
  SELECT_RECIPE_BUILDER: 'Sélectionner Créateur de recettes',
  SELECT_SHIPPING_CHARGE: 'Sélectionner Frais de livraison',
  SELECT_SHIPPING_FORM: "Sélectionner Formulaire d'expédition",
  SELECT_TO: 'Sélectionner À',

  SEND: 'Envoyer',
  SENT: 'Envoyé',
  SEND_RECEIVE: 'Envoyer/Recevoir',
  SENDING_MESSAGES: 'Envoi de messages en cours...',
  SENDING_REPLIES: 'Envoi de réponses en cours...',

  SET_AS_HIGH_PRIORITY: 'Priorité élevée',
  SIGN_IN: 'Se connecter',
  SIGN_IN_PORTAL: 'Portail de connexion Fournisseurs à Order-EZ',

  SHIP_TO: 'Expédier à',
  SHIP_VIA: 'Expédié via',
  SHIPP_DATE: "Date de l'expédition passée",
  SHIPPED_DATE: "Date de l'expédition passée",
  SHIPPED_ORDER_DETAILS: 'Détails de la commande expédiée',
  SHIPPED_QUANTITY: 'Quantité expédiée',
  SHIPPED_QUANTITY_REQUIRED:
    'La quantité expédiée est requise pour tous les articles non annulés',
  SHIPPED_VIA: 'Expédié via',
  SHIPPING: 'Expédition',
  SHIPPING_CALCULATION: "Calcul de l'expédition",
  SHIPPING_CHARGE: "Tarif d'expédition",
  SHIPPING_CHARGES: "Tarifs d'expédition",
  SHIPPING_DATE: "Date d'expédition",
  SHIPPING_DETAILS: "Détails d'expédition",
  SHIPPING_FILTER: "Filtre d'expédition",
  SHIPPING_FORM: "Formulaire d'expédition",
  SHIPPING_ID: "Identifiant d'expédition",
  SHIPPING_MEMO_INVOICE: "Bordereau d'expédition et facture",
  SHIPPING_MEMOS: "Bordereaux d'expédition",
  SHIPPING_MEMO: "Bordereau d'expédition",
  SHIPPING_METHOD: "Méthode d'expédition",
  SHIPPING_QUANTITY: 'Quantité à expédier',
  SHIPPING_RATE: "Frais d'expédition",

  SKU_ID: 'Identifiant UGS',
  SKU_IMAGE: 'Image UGS',
  SKU_NUMBER: 'Numéro UGS (Unité de Gestion de Stock)',
  STATE: 'État',
  STATUS: 'Statut',

  STORE: 'Client',
  STORE_ADDRESS: 'Adresse Client',
  STORE_CITY: 'Ville Client',
  STORE_CONTACT: 'Contact Client',
  STORE_COST: 'Frais Client',
  STORE_COUNTRY: 'Pays Client',
  STORE_DETAILS: 'Détails Client',
  STORE_FILTER: 'Filtre Client',
  STORE_FILTERS: 'Filtres Client',
  STORE_LOGO: 'Logo Client',
  STORE_NAME: 'Nom Client',
  STORE_MOBILE: 'Store Mobile', //not used
  STORE_MODIFIED_SUCCESSFULLY: 'Client modifié avec succès',
  STORE_NOTE: 'Remarque Client',
  STORE_NOTES: 'Remarques Client',
  STORE_NUMBER: 'Numéro Client',
  STORE_PRODUCT_FILTER: 'Filtre Produits Client',
  STORE_PRODUCTS: 'Produits Client',
  STORE_PO: 'Bon de commande Client',
  STORE_PO_NUMBER: 'Numéro Bon de commande Client',
  STORE_PROVINCE: 'État/Province Client',
  STORE_POSTAL_CODE: 'Code postal/ZIP du client',
  STORE_STATE: 'État/Province Client',
  STORE_TAX1: 'Nom de la taxe Client (1)',
  STORE_TAX1_RATE: 'Nom de la taxe Client (1)',
  STORE_TAX2: 'Nom de la taxe Client (2)',
  STORE_TAX2_RATE: 'Nom de la taxe Client (2)',
  STORES: 'Magasins',
  STORE_STATE_PROVINCE: 'Magasin État/Province',
  STATE_PROVINCE: 'État/Province',

  SUB_CATEGORY: 'Sous-catégorie',
  SUB_CATEGORY_NOT_FOUND: 'Aucune sous-catégorie trouvée',
  SUB_TOTAL: 'Sous-total',
  SUBCATEGORY: 'Sous-catégorie',
  SUBCATEGORY_NAME: 'Nom de la sous-catégorie',
  SUBJECT: 'Objet',
  SUBORDER_ID: 'Identifiant de la sous-commande',

  SUPPLIER_NAME: 'Nom du fournisseur',
  SUPPLIER_DETAILS: 'Détails du fournisseur',
  SUPPLIER_NOTES: 'Notes du fournisseur',
  SUPPLIER_PROFILE: 'Profil du fournisseur',
  SUPPLIERS: 'Fournisseurs',

  TAG: 'Étiquette',
  TAX_DESCRIPTION: 'Description de la taxe',
  TAX_NUMBER1: "Numéro d'identification fiscal 1",
  TAX_NUMBER2: "Numéro d'identification fiscal 2",
  TAX_RATE: "Taux d'imposition",
  TAXES: 'Taxes',
  TERMS: 'Conditions',

  TO: 'À',
  TO_ALL_STORES: 'À tous les Clients',
  TO_BE_CONFIRMED: 'À confirmer',
  TOTAL: 'Total',
  TOTAL_INVOICE: 'Total de la facture',
  TOTAL_ORDER_VALUE: 'Valeur totale de la commande',
  TOTAL_ORDERS: 'Total des commandes',
  TOTAL_PRICE: 'Prix total',
  TOTAL_REQUIRED: 'Total requis',
  TYPE: 'Type',
  TYPE_DEACTIVATE_HERE: 'Taper DESACTIVER ici',
  TYPE_REACTIVATE_HERE: 'Taper RÉACTIVER ici',

  UNASSIGN: 'Désassigner',
  UNIT: 'Unité',
  UNIT_PRICE: 'Prix unitaire',
  UNIT_OF_MEASURE: 'Unités de mesure',

  UPDATE: 'Mise à jour',
  UPDATE_CATEGORY_DETAILS: 'Mise à jour des détails de la catégorie...',
  UPDATE_INVOICE_DETAILS: 'Mettre à jour les détails de la facture',
  UPDATE_PRODUCT: 'Mettre à jour le produit',
  UPDATE_PRODUCT_MESSAGE:
    'Êtes-vous sûr(e) de vouloir mettre à jour le statut de ce produit ?',
  UPDATE_SHIPPING_DETAILS: "Mettre à jour les détails d'expédition",
  UPDATING_ORDER_STATUS: 'Mise à jour du statut de la commande en cours...',
  UPDATING_PRODUCT: 'Mise à jour du produit en cours...',
  UPDATING_SUBCATEGORIES_DETAILS:
    'Mise à jour des détails de la sous-catégorie...',

  UPLOAD: 'Télécharger',
  UPLOADING_PRODUCT_IMAGE: "Téléchargement de l'image du profil",
  UPLOADING_INGREDIENT_LABEL_IMAGE:
    "Téléversement de l'image de l'étiquette des ingrédients en cours...",
  UPLOADING_NUTRITION_LABEL_IMAGE:
    "Téléversement de l'image de l'étiquette nutritionnelle en cours ...",
  UPLOADING_PROFILE_IMAGE: "Téléchargement de l'image du profil...",
  UPLOADING_QR_CODE_IMAGE: "Téléversement de l'image du code QR...",
  UPLOADING_SKU_IMAGE: "Téléversement de l'image de l'UGS en cours...",
  UPLOADING_LOGO: 'Téléversement Logo en cours ...',
  URGENT: 'Urgent',
  USERNAME: "Nom d'utilisateur",

  VARIANCE: 'Écart',
  VERSION: 'Version',
  VIEW_ALL: 'Voir tout',
  VIEW_CONSOLIDATED_RECIPE_BUILDER: 'Voir le créateur de recettes consolidé',
  VIEW_STORE_NOTES: 'Voir Remarques Client',
  VIEW_SUPPLIER_NOTES: 'Voir les notes du fournisseur',

  WORK: 'Travail',
  WORK_PHONE_NUMBER: 'Téléphone travail',
  YES: 'Oui',
  YOU_MUST_COMPLETE_ALL_REQUIRED_FEILDS_OR_CHANGES_WILL_BE_LOST:
    'Vous dois Complétez tous les chiffres obligatoires ou les changements seront perdus',
  BACK: 'Dos',
  CONTINUE: 'continuer',
  VIEW_REPLY: 'Voir / Répondre',
  NOTE_YOU_CAN_ENTER_UP_TO_500_CHARACTERS:
    "Remarque: vous pouvez saisir jusqu'à 500 caractères.",
  NO_PRODUCTS_SELECTED_FOR_STATUS_UPDATE:
    'Aucun produit sélectionné pour la mise à jour du statut',
  NO_PRODUCTS_SELECTED_ASSIGNMENT:
    "Aucun produit sélectionné pour l'assignation.",
  NO_PRODUCTS_SELECTED_UNASSIGNMENT:
    'Aucun produit sélectionné pour la désaffectation.',
  SELECT_PRODUCT_NAME: 'Sélectionner Nom du produit',
  ENTER_PRODUCT_ID: "Saisir l'identifiant du produit",
  SELECT_PRODUCT_TYPE: 'Sélectionner Type de produit',
  SELECT_SUB_CATEGORY: 'Sélectionner Sous-catégorie',
  ENTER_RETAIL_PRICE: 'Saisir le prix de détail',
  SELECT_MINIMUM_DELIVERY_TIMEFRAME: 'Sélectionner Délai de livraison minimum',
  SELECT_STATUS: 'Sélectionner Statut',
  ENTER_GENERAL_PRODUCT_COST: 'Saisir le coût général du produit',
  ENTER_DESCRIPTION: 'Saisir la description',
  ENTER_SKU_NUMBER: 'Saisir le numéro UGS',
  ENTER_CATEGORY_NAME: 'Saisir le nom de la catégorie',
  PLEASE_ENTER_PRODUCT_ID: 'Veuillez saisir un identifiant de produit valide',
  ENTER_SUBCATEGORY_NAME: 'Saisir le nom de la sous-catégorie',
  SELECT_DIFFERENT_LEGAL_NAME: 'Sélectionner Nom légal différent',
  SELECT_STATE: 'Sélectionne État',
  ENTER_DISCOUNT_PER: 'Saisir le pourcentage de remise sur le prix de détail',
  ENTER_STORE_TAX1: 'Saisir Nom de la taxe Client (1)',
  ENTER_STORE_TAX2: 'Saisir Nom de la taxe Client (2)',
  ENTER_COMPANY_NAME: 'Saisir le nom de la société',
  ENTER_CITY: 'Saisir la ville',
  ENTER_COMPANY_ADDRESS: "Saisir l'adresse de la société",
  ENTER_POSTAL_CODE: 'Saisir le code postal',
  SELECT_METHOD: 'Sélectionner Méthode',
  SELECT_TERMS: 'Sélectionner Conditions',
  SELECT_SHIP_TO: 'Sélectionner Expédier à',
  SELECT_SHIPPING_METHOD: "Sélectionner Méthode d'expédition",
  ENTER_SHIPPING_CHARGES: 'Saisir les frais de livraison',
  SELECT_SHIPPING_CALCULATION: 'Sélectionner Calcul de livraison',
  SELECT_SHIPPING_CHARGES: 'Sélectionner Frais de livraison',
  ENTER_NAME: 'Saisir nom',
  PLEASE_ENTER_VALID_STORE_POSTAL_CODE:
    'Veuillez saisir un ZIP/Code postal Client valide',
  PLEASE_ENTER_VALID_DISCOUNT_RETAIL_PRICE:
    'Veuillez saisir un pourcentage de remise sur le prix de détail valide',
  PLEASE_ENTER_VALID_EMAIL: 'Veuillez saisir une addresse e-mail valide',
  PLEASE_ENTER_VALID_WORK_NUMBER:
    'Veuillez saisir un numéro de téléphone au travail valide',
  PLEASE_ENTER_VALID_MOBILE:
    'Veuillez saisir un numéro de téléphone mobile valide',
  PLEASE_ENTER_VALID_PARENT_POSTAL_CODE:
    'Veuillez saisir un code postal valide de la société mère',
  PLEASE_ENTER_VALID_PARENT_EMAIL:
    'Veuillez sasir une adresse e-mail de la société mère valide',
  PLEASE_ENTER_VALID_PARENT_WORK_NUMBER:
    'Veuillez saisir un numéro de travail de la société mère valide',
  ENTER_SUBJECT: "Saisir l'objet",
  SELECT_CITY: 'Sélectionner Ville',
  SELECT_POSTAL_CODE: 'Sélectionner Code postal',
  SELECT_PRIORITY: 'Sélectionner Priorité',
  SELECT_PRODUCT: 'Sélectionner Nom du produit',
  INGREDIENTS_ALLREADY_ADDED: 'Cet ingrédient a déjà été ajouté',
  SELECT_PRODUCTION_REPORT: 'Sélectionner Rapport de production',
  PRODUCTION_REPORT_IS_REQUIRED: 'Le rapport de production est requis',
  GETTING_REPORT: 'Chargement du rapport',

  TAX_DESCRIPTION_IS_REQUIRED: 'La description de la taxe est requise',
  TAX_RATE_IS_REQUIRED: "Le taux d'imposition est requis",
  INVALID_IMG_DIMENTIONS:
    'Dimensions de l’image incorrectes. Veuillez utiliser 1280x720 ou 1920x1080',
  NEW_CONFIRM_PASSWORD_IS_NOT_SAME:
    'Les mots de passe ne correspondent pas. Veuillez réessayer.',
  PRICE_MUST_BE_GREATER_THAN_ZERO: 'La Price doit être supérieure à zéro',
  QUANTITY_MUST_BE_GREATER_THAN_ZERO: 'La quantité doit être supérieure à zéro',
  REQUESTED_DELIVERY_DATE_IS_REQUIRED:
    'La date de livraison demandée est requise',
  REQUESTED_DELIVERY_DATE_MUST_IN_FUTURE:
    'La date de livraison demandée doit être ultérieure à aujourd’hui',
  THIS_PRODUCT_IS_ALREADY_ADDED: 'Le produit a déjà été ajouté',
  QUANTITY_MUST_GREATER_THAN_ZERO: 'La quantité doit être supérieure à zéro',
  NO_DATA_FOUND_SUB_FOR_CATEGORY:
    'Aucune donnée trouvée pour la sous-catégorie ',
  SELECT_ALL_ROWS_ASSIGNMENT:
    'Tous les produits ont été sélectionnés pour la mise à jour du statut',
  DUE_DATE_IS_REQUIRED: 'La date d’échéance est requise',
  INGREDIENT_NAME_REQUIRED: "Le nom de l'ingrédient est requis",
  INGREDIENTS_IS_REQUIRED: "L'ingrédient est requis",
  PRODUCT_NAME_CANNOT_SAME: 'Le nom du produit ne peut pas être identique',
  SHIPPING_METHOD_IS_REQUIRED: "La méthode d'expédition est requise",
  TAX_REQUIRED: 'Le numéro de taxe est requis',
  TAX_RATE_REQUIRED: "Le taux d'imposition est requis",
  NO_PRODUCTS_ASSIGNMENT: "Aucun produit sélectionné pour l'assignation",
  FETCHING_INVOICE_DETAILS:
    'Récupération des détails de facturation en cours...',
  FETCHING_PRODUCTION_REPORT:
    'Récupération du rapport de production en cours...',
  CANCELLING_PRODUCTION: 'Annulation de la production en cours...',
  NEW_PRODUCT_ADDED: 'Nouveau produit ajouté avec succès',
  PROCEED_MESSAGE: 'Êtes-vous sûr(e) de vouloir continuer ?',
  CONFIRMATION: 'Confirmation',
  DELETE_ITEM_MESSAGE: 'Êtes-vous sûr(e) de vouloir supprimer cet élément ?',
  CANCEL_CONFIRMATION: "Confirmation d'annulation",
  ORDER_CANCEL_CONFIRM_MESSAGE:
    'Êtes-vous sûr(e) de vouloir annuler cette commande ?',
  ASSIGN_PRODUCT_MESSAGE: 'Êtes-vous sûr(e) de vouloir assigner ce produit ?',
  UNASSIGN_PRODUCT: 'Désassigner le produit',
  UNASSIGN_PRODUCT_MESSAGE:
    'Êtes-vous sûr(e) de vouloir désassigner ce produit ?',
  ENTER_TAX_DESCRIPTION: 'Saisir la description de la taxe',
  ENTER_TAX_RATE: 'Saisir le taux de taxe',
  SPLIT: 'Divisé',
  PLEASE_ENTER_SUPPLIER_TAX1: 'Veuillez saisir une taxe 1 valide',
  PLEASE_ENTER_SUPPLIER_TAX2: 'Veuillez saisir une taxe 2 valide',
  ENTER_SUPPLIER_TAX1: "Saisir le taux d'imposition (1) du fournisseur",
  ENTER_SUPPLIER_TAX2: "Saisir le taux d'imposition (1) du fournisseur",
  SUPPLIER_TAX1: "Numéro d'identification fiscal (1)",
  SUPPLIER_TAX2: "Numéro d'identification fiscal (2)",
  ZERO_QUANTITY_NOT_ALLOWED: "Une quantité de zéro n'est pas autorisée",
  CONFIRMED_QUANTITY: 'Quantité confirmée',
  ZERO_PRICE_NOT_ALLOWED: "Un prix de zéro n'est pas autorisé",
  ENTER_SHIPPING_METHOD: "Saisit Méthode d'expédition",
  FETCHING_SHIP_TO_DETAILS:
    "Récupération Détails Destination d'expédition en cours ...",
  UPDATED_SHIPPING_DETAILS_SUCCESSFULLY: "Mise à jour Détails d'expédition",
  INVALID_IMAGE_DIMENTIONS:
    'Dimensions de l’image incorrectes. Veuillez utiliser 1280x720 ou 1920x1080',

  IMAGE_UPLOAD_MESSAGE:
    "Formats d'images acceptés : JPG, PNG, JPEG | Taille max fichier : 2MB | Résolution recommandée : 1280x720 pixels",
  DEFAULT_SHIP_TO: "Destination d'expédition par défaut : Client", //store->client
  DOWNLOADING_PRODUCTION_PLAN: 'Téléchargement Plan de production',
  VIEW: 'Voir',
  DOWNLOADING_CONSOLIDATED_RECIPE_BUILDER: 'Téléchargement Plan de production',
  DOWNLOADING_RECIPE_BUILDER_SINGLE:
    'Téléchargement Créateur de Recettes pour un seul produit',
  DOWNLOADING_SHIPING_DETAILS: "Téléchargemebt des détails d'expédition",
  DOWNLOADING_INVOICE_DETAILS: 'Téléchargement des détails de la facture',

  STORE_EMAIL: 'E-mail Client', //store->client
  PLEASE_TYPE_DEACTIVATE: 'Veuillez taper DÉACTIVER',
  PLEASE_TYPE_REACTIVATE: 'Veuillez taper RÉACTIVER',

  VIEW_ALL_ORDERS: 'Afficher toutes les commandes dues à la date sélectionnée.',
  UNASSIGN_FROM_ALL_STORES: "Supprimer l'affectation de tous les Clients",
  ADD_TO_ALL_STORES: 'Ajouter à tous les Clients', //store->client

  USA: 'États-Unis',
  CANADA: 'Canada',
  // Canada State--
  ONTARIO: 'Ontario',
  QUEBEC: 'Québec',
  NOVA_SCOTIA: 'Nouvelle-Écosse',
  NEW_BRUNSWICK: 'Nouveau-Brunswick',
  MANITOBA: 'Manitoba',
  BRITISH_COLUMBIA: 'Colombie Britannique',
  PRINCE_EDWARD_ISLAND: 'Île-du-Prince-Édouard',
  SASKATCHEWAN: 'Saskatchewan',
  ALBERTA: 'Alberta',
  NEWFOUNDLAND_AND_LABRADOR: 'Terre-Neuve-et-Labrador',

  // USA State--
  ALABAMA: 'Alabama',
  ALASKA: 'Alaska',
  ARIZONA: 'Arizona',
  ARKANSAS: 'Arkansas',
  CALIFORNIA: 'Californie',
  COLORADO: 'Colorado',
  CONNECTICUT: 'Connecticut',
  DELAWARE: 'Delaware',
  DISTRICT_OF_COLUMBIA: 'District de Colombia (Washington, D.C.)',
  FLORIDA: 'Floride',
  GEORGIA: 'Géorgie',
  HAWAII: 'Hawaï',
  IDAHO: 'Idaho',
  ILLINOIS: 'Illinois',
  INDIANA: 'Indiana',
  IOWA: 'Iowa',
  KANSAS: 'Kansas',
  KENTUCKY: 'Kentucky',
  LOUISIANA: 'Louisiana',
  MAINE: 'Maine',
  MARYLAND: 'Maryland',
  MASSACHUSETTS: 'Massachusetts',
  MICHIGAN: 'Michigan',
  MINNESOTA: 'Minnesota',
  MISSISSIPPI: 'Mississippi',
  MISSOURI: 'Missouri',
  MONTANA: 'Montana',
  NEBRASKA: 'Nebraska',
  NEVADA: 'Nevada',
  NEW_HAMPSHIRE: 'New Hampshire',
  NEW_JERSEY: 'New Jersey',
  NEW_MEXICO: 'Nouveau-Mexique',
  NEW_YORK: 'New York',
  NORTH_CAROLINA: 'Caroline du Nord',
  NORTH_DAKOTA: 'Dakota du Nord',
  OHIO: 'Ohio',
  OKLAHOMA: 'Oklahoma',
  OREGON: 'Oregon',
  PENNSYLVANIA: 'Pennsylvania',
  RHODE_ISLAND: 'Rhode Island',
  SOUTH_CAROLINA: 'Caroline du Sud',
  SOUTH_DAKOTA: 'Dakota du Sud',
  TENNESSEE: 'Tennessee',
  TEXAS: 'Texas',
  UTAH: 'Utah',
  VERMONT: 'Vermont',
  VIRGINIA: 'Virginie',
  WASHINGTON: 'Washington',
  WEST_VIRGINIA: 'Virginie-Occidentale',
  WISCONSIN: 'Wisconsin',
  WYOMING: 'Wyoming',

  B2B: 'B2B',
  B2C: 'B2C (à venir)',
  PICKUP: 'Retrait',
  OTHER: 'Autre',
  ALL: 'Tous',
  UNAVAILABLE: 'Temporairement indisponible',
  PURCHASED: 'Acheté',
  MANUFACTURED: 'Fabriqué',
  PROCESSED: 'Traité',
  INPRODUCTION: 'En production',
  SHIPPED: 'Délivré',
  INVOICED: 'Facturé',
  COMPLETE: 'Complété',
  CANCELLED: 'Annulé',
  BY_STORE: 'Par Client',
  BY_PRODUCT: 'Par produit',

  // Payment Methods
  CREDIT_CARD: 'Carte de crédit',
  INTERAC: 'Interac',
  LINE: 'Line',
  TBA: 'À venir',
  CHAINSTORE: 'Commerce de chaîne',
  ASSIGNED: 'Attribué',
  UNASSIGNED: 'Non attribué',
  // BakeryPrepByPercentage: 'Prépararion boulangerie par pourcentage',
  // FoodPrepByWeight: 'Prépararion des aliments par poids',
  ENTER_PHONE_NUMBER: 'Saisir le numéro de téléphone',
  PERCENTAGE: 'Pourcentage',
  AMOUNT: 'Quantité',
  ENTER_NOTE: 'Saisir une note',

  ENTER_UNIT_OF_MEASURE: "Saisir l'unité de mesure",
  ENTER_QUANTITY_PER_UNIT: 'Saisir la quantité par unité',
  ENTER_COST_PRICE: 'Saisir le prix de revient',
  ENTER_INGREDIENT_NAME: "Saisir le nom de l'ingrédient",
  SELECT_COUNTRY: 'Sélectionner Pays',
  MESSAGE_TO: 'Message à',
  ADD_NEW_SHIPPING_METHOD: 'Ajouter une nouvelle méthode de livraison',
  ADD_NEW_INGREDIENT: 'Ajouter nouvel Ingrédient',
  CATEGORY_UPDATE_SUCCESS: 'Catégorie mise à jour avec succès',
  CATEGORY_UPDATE_FAIL: 'Échec de la mise à jour de Catégorie',
  CATEGORY_ADDED_SUCCESS: 'Catégorie ajoutée avec succès',
  CATEGORY_ADDITION_FAILED: "Échec de l'ajout de Catégorie",
  INGREDIENT_CREATED_SUCCESS: 'Ingrédient créé avec succès',
  INGREDIENT_CREATION_FAILED: 'Échec de la création de Ingrédient',
  INVOICE_CREATED_SUCCESS: 'Facture créée avec succès',
  INVOICE_CREATION_FAILED: 'Échec création Facture',
  ORDER_STATUS_CHANGED_SUCCESS: 'Statut de Commande modifié avec succès',
  ORDER_STATUS_CHANGE_FAILED: 'Échec de modification de Commande',
  ORDER_SPLIT_SUCCESS: 'Commande partagée avec succès',
  ORDER_SPLIT_FAILED: 'Échec du partage de Commade',
  CONFIRM_PRODUCTION_SAVED_SUCCESS:
    'Échec de la sauvegarde de Production confirmée',
  CONFIRM_PRODUCTION_SAVE_FAILED:
    'Échec de la sauvegarde de Production confirmée',
  ORDER_SHIPPED_SUCCESS: 'Commande expédiée avec succés',
  ORDER_SHIPPED_FAILED: 'Échec expédition Commande',
  ORDER_CANCELLED_SUCCESS: 'Commande annulée avec succès',
  ORDER_CANCELLED_FAILED: "Échec de l'annulation de Commande",
  PRODUCTS_ASSIGNED_SUCCESS: 'Produits assignés avec succès',
  PRODUCTS_ASSIGN_FAILED: "Échec de l'assignation des Produits",
  PRODUCT_DEACTIVATED_SUCCESS: 'Produit désactivé avec succès',
  PRODUCT_DEACTIVATION_FAILED: 'Échec désactivation Produit',
  PRODUCT_REACTIVATED_SUCCESS: 'Produit réactivé avec succès',
  PRODUCT_REACTIVATION_FAILED: 'Échec réactivation Produit',
  PRODUCT_UPDATED_SUCCESS: 'Produit mis à jour avec succès',
  PRODUCT_UPDATE_FAILED: 'Échec mise à jour Produit',
  PROFILE_UPLOADED_SUCCESS: 'Profil téléversé avec succès',
  PROFILE_UPLOAD_FAILED: 'Échec téléversement Profil',
  TAX_ADDED_SUCCESS: 'Taxe ajoutée avec succès',
  TAX_ADD_FAILED: 'Échec ajout Taxe',
  SUBCATEGORY_ADDED_SUCCESS: 'Sous-catégorie ajoutée avec succès',
  SUBCATEGORY_ADD_FAILED: 'Échec ajout Sous-catégorie',
  SUBCATEGORY_UPDATED_SUCCESS: 'Sous-catégorie mise à jour avec succès',
  SUBCATEGORY_UPDATE_FAILED: 'Échec mise à jour Sous-catégorie',

  BY_WEIGHT: 'par poids',
  BY_PERCENTAGE: 'par pourcentage',
  PARENT_PROVINCE: 'État/Province du parent',
  ALL_ORDERS_DUE_ON: 'Toutes les Commandes dues le',
  ORDERS_DUE_ON: 'Commandes dues le',
  ORDERS_DUE_TO: 'Commandes dues à',
  ORDERS_DUE_FROM: 'Commandes dues à partir du',
  SHIPPING_CHARGE_PERCENTAGE: 'FShipping charge Percentage',
  SHIPPING_CHARGE_AMOUNT: 'FShipping charge Amount',
  POWERED_BY_ORDER_EZ: 'FPowered by Order-EZ.com',
  SHIPPED_ORDER_STATUS: 'FShipped Order Status',
  PACKED_ORDER_STATUS: 'FPacked Order Status',
  FETCHING_DATA: 'FFetching Data',
  ADDING_NEW_TAX: 'FAdding New Tax',
};
